import { Component, ViewChildren, QueryList, ElementRef } from '@angular/core';

@Component({
  selector: 'app-products-filters',
  templateUrl: './products-filters.component.html',
  styleUrls: ['./products-filters.component.scss']
})
export class ProductsFiltersComponent {
  @ViewChildren('menuItem') menuItems: QueryList<ElementRef>;

  scrollTo(filter: HTMLElement) {
    const sectionToScroll: HTMLElement = document.querySelector('.filter.' + filter.classList[0]);

    this.menuItems.forEach( menuItem => {
      menuItem.nativeElement.classList.remove('active');
    })

    filter.classList.add('active');

    window.scrollTo({
      top: sectionToScroll.offsetTop - 32,
      left: 0,
      behavior: 'smooth'
    });
    
  }

}
